import React from 'react';
import {
  ACCENT,
  ACCENT_LIGHT,
  ACCENT_BORDER,
  CARD,
  TEXT_DARK,
  TEXT_MID,
  FONT,
} from '../../lib/tokens';

export const ScreenWrap = ({ children, noPad }) => (
  <div
    style={{
      flex: 1,
      overflowY: 'auto',
      overflowX: 'hidden',
      padding: noPad ? 0 : '0 18px 16px',
      display: 'flex',
      flexDirection: 'column',
      gap: 10,
    }}
  >
    {children}
  </div>
);

export const SectionLabel = ({ children }) => (
  <div
    style={{
      fontSize: 10.5,
      fontWeight: 700,
      color: 'rgba(255,255,255,0.32)',
      letterSpacing: '0.1em',
      textTransform: 'uppercase',
      marginBottom: 2,
      marginTop: 6,
    }}
  >
    {children}
  </div>
);

export const Card = ({ children, style }) => (
  <div
    style={{
      background: CARD,
      borderRadius: 13,
      padding: '14px 16px',
      boxShadow: '0 1px 10px rgba(0,0,0,0.1)',
      flexShrink: 0,
      ...style,
    }}
  >
    {children}
  </div>
);

export const GhostCard = ({ children, style }) => (
  <div
    style={{
      background: 'rgba(255,255,255,0.05)',
      border: '1px solid rgba(255,255,255,0.08)',
      borderRadius: 13,
      padding: '14px 16px',
      flexShrink: 0,
      ...style,
    }}
  >
    {children}
  </div>
);

export const Tag = ({ children, color, style }) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      background: color ? `${color}22` : ACCENT_LIGHT,
      border: `1px solid ${color ? `${color}44` : ACCENT_BORDER}`,
      color: color || ACCENT,
      fontSize: 10.5,
      fontWeight: 700,
      letterSpacing: '0.06em',
      borderRadius: 20,
      padding: '2px 9px',
      ...style,
    }}
  >
    {children}
  </span>
);

export const SubmitBtn = ({ children, onClick, accent, disabled, style }) => (
  <button
    onClick={onClick}
    disabled={disabled}
    style={{
      background: disabled ? '#cbd5e1' : accent || ACCENT,
      border: 'none',
      borderRadius: 9,
      padding: '11px 20px',
      color: '#fff',
      fontSize: 13.5,
      fontWeight: 600,
      cursor: disabled ? 'not-allowed' : 'pointer',
      fontFamily: FONT,
      width: '100%',
      letterSpacing: '0.01em',
      ...style,
    }}
  >
    {children}
  </button>
);

export const Field = ({ label, value, onChange, placeholder, multiline, type = 'text' }) => (
  <div style={{ display: 'flex', flexDirection: 'column', gap: 5 }}>
    <label
      style={{
        fontSize: 11.5,
        fontWeight: 600,
        color: TEXT_MID,
        letterSpacing: '0.04em',
      }}
    >
      {label}
    </label>
    {multiline ? (
      <textarea
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        rows={3}
        style={{
          border: '1.5px solid #e2e8f0',
          borderRadius: 8,
          padding: '9px 11px',
          fontSize: 13.5,
          color: TEXT_DARK,
          resize: 'none',
          fontFamily: FONT,
          outline: 'none',
          background: '#fff',
          lineHeight: 1.45,
        }}
      />
    ) : (
      <input
        type={type}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        style={{
          border: '1.5px solid #e2e8f0',
          borderRadius: 8,
          padding: '9px 11px',
          fontSize: 13.5,
          color: TEXT_DARK,
          fontFamily: FONT,
          outline: 'none',
          background: '#fff',
        }}
      />
    )}
  </div>
);
